import React from 'react';
import { Grid } from 'theme-ui';
import AnimatedSlidingToggle from '~/components/Generic/AnimatedSlidingToggle';
import QuickshopProductCard from './ProductCard';
import { useSiteWideGender } from '~/hooks/components/use-site-wide-gender';
import QuickshopBundleCard from './BundleCard';
import { isBundleSpotlight, isKitSpotlight, isProductSpotlight } from '../utils';

type Props = {
  shoppingCollections: Queries.QuickShopProductCollectionFragment[];
  activity?: string;
};

const QuickshopSection = ({ shoppingCollections, activity }: Props) => {
  const tabs = shoppingCollections.map((collection) => ({
    value: collection.title ?? '',
    label: collection.title ?? '',
  }));

  const [currentActiveButtonIndex, setCurrentActiveButtonIndex] = useSiteWideGender(null, tabs);

  const handleSlidingToggleClick = (value: string) => {
    const index = tabs.findIndex((tab) => tab.value === value);
    setCurrentActiveButtonIndex(index);
  };

  return (
    <Grid
      id={`quickshop-${activity}`}
      sx={{
        justifyItems: 'center',
        maxWidth: 'var(--max-width)',
        mx: 'auto',
        scrollMarginTop: 'calc(180px + var(--nav-height))',
      }}
    >
      {shoppingCollections.length > 1 ? (
        <AnimatedSlidingToggle
          tabs={tabs}
          currentActiveButtonIndex={currentActiveButtonIndex ?? 0}
          handleClick={handleSlidingToggleClick}
          pillFitContent={false}
        />
      ) : null}
      {shoppingCollections.map((collection, index) => (
        <Grid
          key={collection.id}
          sx={{
            display: index === currentActiveButtonIndex ? 'grid' : 'none',
            gap: ['1.6rem', '0.8rem', '2.4rem'],
            gridTemplateColumns: ['1fr', `repeat(${collection.spotlights?.length}, 1fr)`],
          }}
        >
          {collection.spotlights?.map((spotlight) => {
            if (!spotlight) return null;
            const layout = collection?.spotlights?.length === 2 ? 'horizontal' : 'vertical';
            if (isProductSpotlight(spotlight)) {
              return <QuickshopProductCard key={spotlight?.id} spotlight={spotlight} layout={layout} />;
            }
            if (isBundleSpotlight(spotlight) || isKitSpotlight(spotlight)) {
              return <QuickshopBundleCard key={spotlight?.id} spotlight={spotlight} layout={layout} />;
            }
            return null;
          })}
        </Grid>
      ))}
    </Grid>
  );
};

export default QuickshopSection;
